import { BaseObject } from '../shared/baseClass';

export class Gift extends BaseObject {


  id: string;
  title: string;
  videoUrl: string;
  friendlyUrl: string;
  price: number;
  paidAmount: number;
  paidPercent: number;
  remaining: number;
  type: string;
  views: number;
  location: string;
  status: string;
  description: string;
  imageUrl: string;
  giftTypeSelection: string;
  removing: boolean;
  selected: boolean;
  editing: boolean;
  hex: string;
  imageName: string;
  removingConfirmed: boolean;
  category: string;
  registryId: string;
  hidePrice: boolean;
  cropParams: string;
  createdFromGiftAssistant: boolean;
  editedAfterGiftAssistant: boolean;
  campaign: string;
  giftTemplateName: string;
  source: string;
  partnershipId: string;
  showGiftAmount: boolean;
  featuredGift: boolean;
  portions: number;
  pricePerPortion: number;
  fromTemplate: boolean;
  templateGiftId: string;
  fromRegistry: string;
  website: string;
  websiteLinkText:string;
  showTranslation: boolean;
  titleTranslation:string;
  descriptionTranslation:string;
  anonGiftId: string;
  mustBuyEntireGift : boolean;
  hideFundingProgress : boolean;
  giftImageUrls: string[];

}








// WEBPACK FOOTER //
// ./src/app/gift/gift.ts